/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".newversion_text[_ngcontent-%COMP%]{font-size:20px;text-align:center}\n/*# sourceMappingURL=dialog-version-update.component.css.map*/"];
export { styles as styles };
